import { Controller } from "stimulus"

export default class extends Controller {
  handleResponse({ detail: [xhr] }) {
    this.element.outerHTML = xhr.responseText
  }
}
